import React, { useRef, useState } from 'react';

export default function SectionList({ sections, onChange, expandedSection, onToggleExpand }) {
  const [dragIndex, setDragIndex] = useState(null);
  const [overIndex, setOverIndex] = useState(null);
  const dragItem = useRef(null);

  const handleDragStart = (idx) => {
    dragItem.current = idx;
    setDragIndex(idx);
  };

  const handleDragEnter = (idx) => {
    setOverIndex(idx);
  };

  const handleDragEnd = () => {
    if (dragItem.current !== null && overIndex !== null && dragItem.current !== overIndex) {
      const updated = [...sections];
      const [moved] = updated.splice(dragItem.current, 1);
      updated.splice(overIndex, 0, moved);
      onChange(updated);
    }
    dragItem.current = null;
    setDragIndex(null);
    setOverIndex(null);
  };

  const toggleEnabled = (idx) => {
    const updated = sections.map((s, i) =>
      i === idx ? { ...s, enabled: !s.enabled } : s
    );
    onChange(updated);
  };

  const updateLabel = (idx, label) => {
    const updated = sections.map((s, i) =>
      i === idx ? { ...s, label } : s
    );
    onChange(updated);
  };

  return (
    <ul className="section-list">
      {sections.map((section, idx) => (
        <li
          key={section.key}
          className={`section-item${dragIndex === idx ? ' dragging' : ''}${overIndex === idx ? ' drag-over' : ''}`}
          draggable
          onDragStart={() => handleDragStart(idx)}
          onDragEnter={() => handleDragEnter(idx)}
          onDragOver={(e) => e.preventDefault()}
          onDragEnd={handleDragEnd}
        >
          <span className="drag-handle">&#x2630;</span>

          <label className="toggle">
            <input
              type="checkbox"
              checked={section.enabled}
              onChange={() => toggleEnabled(idx)}
            />
            <span className="slider" />
          </label>

          <span className="section-label">
            <input
              type="text"
              value={section.label}
              onChange={(e) => updateLabel(idx, e.target.value)}
            />
          </span>

          <span className="section-key">{section.key}</span>

          <button
            className="expand-btn"
            onClick={() => onToggleExpand(section.key)}
            title="Configure columns"
          >
            {expandedSection === section.key ? '▲' : '▼'}
          </button>
        </li>
      ))}
    </ul>
  );
}
